<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ dialogTitle | translate }}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="p-2 m-0">
    <div class="communication-wraper">
      <div class="communication-form" [ngStyle]="{'width': action === 'sms' ? '100%' : '50%'}">

        <mat-form-field>
          <mat-select placeholder="{{'Templates' | translate}}" (selectionChange)="changeTemplate($event)">
            <mat-option>-- None --</mat-option>
            @for (template of templates; track template.id) {
              <mat-option [value]="template.id">
                {{ template.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-accordion [multi]="true">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ ('communication.' + action + '.title') | translate }}
              </mat-panel-title>
              <mat-panel-description>
                {{ ('communication.' + action + '.info') | translate }}
              </mat-panel-description>

            </mat-expansion-panel-header>
            @if (action === 'mail') {
              <form [formGroup]="formGroupMail" class="canton-form">
                <mat-form-field class="width-100">
                  <mat-label>{{ 'setting.To' | translate }}</mat-label>
                  <mat-chip-grid #mailsChipGrid formControlName="mails">
                    @for (mail of mails; track mail) {
                      <mat-chip-row (removed)="removeReactiveKeyword(mail, 'mails', 'formGroupMail')">
                        {{ mail }}
                        <button matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                  <input placeholder="{{'type_email_and_press_enter' | translate}}"
                    [matChipInputFor]="mailsChipGrid"
                    (matChipInputTokenEnd)="addReactiveKeyword($event, 'mails', 'formGroupMail')"
                  />
                </mat-form-field>
                <mat-form-field class="width-100">
                  <mat-label>{{ 'setting.Cc' | translate }}</mat-label>
                  <mat-chip-grid #ccChipGrid formControlName="cc">
                    @for (c of cc; track c) {
                      <mat-chip-row (removed)="removeReactiveKeyword(c, 'cc', 'formGroupMail')">
                        {{ c }}
                        <button matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                  <input placeholder="{{'type_email_and_press_enter' | translate}}"
                         [matChipInputFor]="ccChipGrid"
                         (matChipInputTokenEnd)="addReactiveKeyword($event, 'cc', 'formGroupMail')"
                  />
                </mat-form-field>
                <mat-form-field class="width-100">
                  <mat-label>{{ 'setting.Bcc' | translate }}</mat-label>
                  <mat-chip-grid #bccChipGrid formControlName="bcc">
                    @for (bc of bcc; track bc) {
                      <mat-chip-row (removed)="removeReactiveKeyword(bc, 'bcc', 'formGroupMail')">
                        {{ bc }}
                        <button matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                  <input placeholder="{{'type_email_and_press_enter' | translate}}"
                    [matChipInputFor]="bccChipGrid"
                    (matChipInputTokenEnd)="addReactiveKeyword($event, 'bcc', 'formGroupMail')"
                  />
                </mat-form-field>
                <mat-form-field class="width-100">
                  <mat-label>{{ 'setting.Subject' | translate }}</mat-label>
                  <input formControlName="subject" matInput>
                </mat-form-field>
                <quill-editor [(ngModel)]="body" [modules]="{toolbar:quillConfig}"
                              [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange($event)"
                              id="descriptionEditor">
                </quill-editor>
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.save_as_template' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="description"></textarea>
                </mat-form-field>
              </form>
            }

            @if (action === 'sms' || action === 'whatsapp') {
              <form [formGroup]="formGroupSms" class="canton-form">
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.Descripition' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="description"></textarea>
                </mat-form-field>
                <mat-form-field class="width-100">
                  <mat-label>{{ 'setting.Numbers' | translate }}</mat-label>
                  <mat-chip-grid #bccChipGrid formControlName="numbers">
                    @for (number of numbers; track number) {
                      <mat-chip-row (removed)="removeReactiveKeyword(number, 'numbers', 'formGroupSms')">
                        {{ number }}
                        <button matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                  <input
                    [matChipInputFor]="bccChipGrid"
                    (matChipInputTokenEnd)="addReactiveKeyword($event, 'numbers', 'formGroupSms')"
                  />
                </mat-form-field>
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.Text' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="text"></textarea>
                </mat-form-field>
              </form>
            }

            @if (action === 'serial') {
              <form [formGroup]="formGroupSerial" class="canton-form">
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.Descripition' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="description"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.User' | translate }}</mat-label>
                  <mat-select formControlName="users" required multiple>
                    @for (user of usersData; track user) {
                      <mat-option [value]="user.value">
                        {{ user.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'setting.Text' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="text"></textarea>
                </mat-form-field>
              </form>
            }
            @if (action === 'serial') {
              <div>
                <div>
                  <mat-form-field>
                    <input [(ngModel)]="date" matInput [matDatepicker]="picker"
                           placeholder="{{'Choose_a_date' | translate}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div>
                  <mat-checkbox [(ngModel)]="showFullName">{{ 'show_full_name' | translate }}</mat-checkbox>
                  <mat-form-field class="example-full-width">
                    <input [(ngModel)]="welcome" matInput placeholder="{{'Welcome' | translate}}" value="">
                  </mat-form-field>
                  <mat-form-field class="example-full-width">
                    <textarea [(ngModel)]="end" matInput placeholder="{{'End' | translate}}" value=""></textarea>
                  </mat-form-field>
                </div>
              </div>
            }
          </mat-expansion-panel>
          @if (action === 'mail' || action === 'serial') {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                @if (action === 'serial') {
                  <mat-panel-title>
                    {{ 'Config' | translate }}
                  </mat-panel-title>
                }
                @if (action === 'mail') {
                  <mat-panel-title>
                    {{ 'mail_settings' | translate }}
                  </mat-panel-title>
                }
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              @if (action === 'mail') {
                <div>
                  <mat-radio-group [(ngModel)]="typeOfMessage" class="type-of-message"
                                   (ngModelChange)="changeType($event)">
                    <mat-radio-button value="group">{{ 'Group_message' | translate }}</mat-radio-button>
                    <mat-radio-button value="personal">{{ 'Personal_message' | translate }}</mat-radio-button>
                    <mat-radio-button value="family">{{ 'family' | translate }}</mat-radio-button>
                  </mat-radio-group>
                </div>
              }
              @if (action === 'mail' && organization) {
                <div>
                  <mat-checkbox (change)="rebuildHtml()"
                                [(ngModel)]="organizationLogo">{{ 'Organization_Logo' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (action === 'serial' && organization) {
                <div>
                  <mat-checkbox (change)="downloadPDF(false)"
                                [(ngModel)]="organizationLogo">{{ 'Organization_Logo' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (action === 'serial') {
                <div>
                  <mat-checkbox (change)="downloadPDF(false)"
                                [(ngModel)]="inviteUrl">{{ 'Invite_Url' | translate }}
                  </mat-checkbox>
                </div>
              }
              <!--            <div *ngIf="action === 'serial'" style="margin: 10px 0">-->
              <!--              <mat-checkbox (change)="downloadPDF(false)"-->
              <!--                            [(ngModel)]="showInviteQrCodes">{{'invite_qr_code' | translate}}</mat-checkbox>-->
              <!--            </div>-->
              <!--            <div *ngIf="action === 'mail'" style="margin: 10px 0">-->
              <!--              <mat-checkbox [(ngModel)]="showInviteQrCodes">{{'invite_qr_code' | translate}}</mat-checkbox>-->
              <!--            </div>-->
              @if (action === 'serial' && isOrgAdmin) {
                <div style="margin: 10px 0">
                  <mat-checkbox (change)="downloadPDF(false)"
                                [(ngModel)]="showRegisterQrCodes">{{ 'invite_qr_code' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (action === 'mail' && isOrgAdmin) {
                <div style="margin: 10px 0">
                  <mat-checkbox [(ngModel)]="showRegisterQrCodes">{{ 'invite_qr_code' | translate }}</mat-checkbox>
                </div>
              }
              @if (action === 'mail' && organization) {
                <div>
                  <mat-checkbox (change)="rebuildHtml()"
                                [(ngModel)]="organizationInfo">{{ 'Organization_Info' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (action === 'serial') {
                <div>
                  <mat-radio-group [(ngModel)]="typeOfLetter" (ngModelChange)="typeOfLetterChanges()">
                    <mat-radio-button value="left">{{ 'Left_address_position' | translate }}</mat-radio-button>
                    <mat-radio-button value="right">{{ 'Right_address_position' | translate }}</mat-radio-button>
                  </mat-radio-group>
                  <br>
                  <div>
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="{{'Left' | translate}}" type="number" value="0" [(ngModel)]="left"
                             (ngModelChange)="downloadPDF(false)">
                      <span matSuffix>mm</span>
                    </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="{{'Top' | translate}}" type="number" value="0" [(ngModel)]="top"
                             (ngModelChange)="downloadPDF(false)">
                      <span matSuffix>mm</span>
                    </mat-form-field>
                  </div>
                </div>
              }
            </mat-expansion-panel>
          }
          @if (action === 'mail') {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>{{ 'main.documents' | translate }}</mat-panel-title>
                <mat-panel-description>
                  {{ 'event.upload_documents' | translate }}
                  <mat-icon>insert_drive_file</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <document-tab [type]="'newEmail'"
                            (filesToUpload)="updateData({files: $event})"></document-tab>
            </mat-expansion-panel>
          }
        </mat-accordion>

      </div>
      @if (action === 'mail' || action === 'serial') {
        <div class="communication-preview">
          @if (action === 'mail') {
            <div [innerHTML]="mailBody">
            </div>
          }
          @if (action === 'serial' && pdfScr) {
            <div class="pdf-preview">
              <pdf-viewer [original-size]="true"
                          [fit-to-page]="true"
                          style="width: 100%; height: 100%"
                          [src]="pdfScr" class="rounded"></pdf-viewer>
              <!--          <div id="example1"></div>-->
            </div>
          }
        </div>
      }


    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign=" center">
      @if (action === 'mail') {
        <button
          mat-raised-button
          (click)="sendEmail()"
          class="save-button mat-accent"
          [disabled]="formGroupMail.invalid"
          aria-label="SAVE">
          {{ 'communication.send' | translate }}
        </button>
      }
      @if (action === 'sms') {
        <button
          mat-raised-button
          (click)="sendSMS()"
          class="save-button mat-accent"
          [disabled]="formGroupSms.invalid"
          aria-label="SAVE">
          {{ 'Send_SMS' | translate }}
        </button>
      }
      @if (action === 'whatsapp') {
        <button
          mat-raised-button
          (click)="sendWhatapp()"
          class="save-button mat-accent"
          [disabled]="formGroupSms.invalid"
          aria-label="SAVE">
          {{ 'Send_Whatsapp' | translate }}
        </button>
      }
      @if (action === 'serial') {
        <button
          mat-raised-button
          (click)="sendSerial()"
          class="save-button mat-accent"
          [disabled]="formGroupSerial.invalid"
          aria-label="SAVE">
          {{ 'communication.serial' | translate }}
        </button>
      }
      @if (action === 'serial') {
        <button
          mat-raised-button
          (click)="downloadPDF(true)"
          class="save-button mat-accent"
          [disabled]="formGroupSerial.invalid"
          aria-label="SAVE">
          {{ 'Download_PDF' | translate }}
        </button>
      }
      @if (action === 'serial') {
        <button
          mat-raised-button
          (click)="downloadPDF(false)"
          class="save-button mat-accent"
          [disabled]="formGroupSerial.invalid"
          aria-label="SAVE">
          {{ 'Generate_Preview_PDF' | translate }}
        </button>
      }
      @if (action === 'serial') {
        <button
          mat-raised-button
          (click)="downloadDOCX()"
          class="save-button mat-accent"
          [disabled]="formGroupSerial.invalid"
          aria-label="SAVE">
          {{ 'Download_DOCX' | translate }}
        </button>
      }
    </div>
  </div>
</div>
